export default __webpack_public_path__ + "static/media/skip.f7691a7b.svg";